<ul class="loading-feedback" [class.loading-feedback-inline]="inline">
    <li></li>
    <li></li>
    <li></li>
</ul>